export enum DealType {
  AllDeals = 'All Deals',
  Lease = 'Lease',
  Finance = 'Finance',
  Cash = 'Cash',
  Service = 'Service',
  New = 'New',
  Unknown = 'Unknown',
}
